"use client";

import { useEffect } from "react";
import { useMediaAuth } from "@/hooks/useMediaAuth";

/**
 * Runs the initial auth-session check once at app boot so route-level screens
 * can read a hydrated auth store immediately.
 */
export default function AuthBootstrap() {
  const { checkSession } = useMediaAuth();

  useEffect(() => {
    void checkSession();
  }, [checkSession]);

  return null;
}
